import React from 'react';
import useRelationship from 'Hooks/useRelationship';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import {
  ActivityTabLayout,
} from 'Views/Page/Content/Templates/MemberDashboard/content/ActivityTabs/content/ActivityTabLayout/ActivityTabLayout';

const ActivityTabContainer = ({ relationship, showFilters }) => {
  const {
    isInitializing,
    loadingError,
    collection,
  } = useRelationship(
    relationship,
  );

  return (
    <DataContainer
      component={ActivityTabLayout}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        collection,
        showFilters,
      }}
    />
  );
};

ActivityTabContainer.defaultProps = {
  showFilters: false,
};

ActivityTabContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
  showFilters: PropTypes.bool,
};

export { ActivityTabContainer };
